// @flow

/* Allowing every URL to be sent as a tag in StatsD would give us an unbounded number of URLs. Instead we match URLs with regexes, then give them a static tag. */

// MORE SPECIFIC REGEXES MUST GO FIRST, FIRST MATCH WINS
const urlTagMapArray: Array<{ regex: RegExp, tag: string }> = [
  {
    regex: /https:\/\/api\.lever\.co\/v0\/postings\/rover\?group=team&mode=json/,
    tag: 'https://api.lever.co/v0/postings/rover?group=team&mode=json',
  },
  { regex: /\/frontend\/current-user\//, tag: '/frontend/current-user/' },
  { regex: /\/frontend\/experiments\//, tag: '/frontend/experiments/' },
  { regex: /\/search-optimized\//, tag: '/search-optimized/' },
  { regex: /\/people\/[a-zA-Z0-9]+\/home\//, tag: '/people/:personOpk/home/' },
  { regex: /\/cities-and-neighborhoods\//, tag: '/cities-and-neighborhoods/' },
  {
    regex: /\/country-configuration\/current\//,
    tag: '/country-configuration/current/',
  },
  { regex: /\/country-configuration\//, tag: '/country-configuration/' },
  { regex: /\/frontend\/country-footer-links\//, tag: '/country-footer-links/' },
  { regex: /\/frontend\/country-region-links\//, tag: '/frontend/country-region-links/' },
  { regex: /\/frontend\/events\//, tag: '/frontend/events/' },
  { regex: /\/frontend\/configuration\//, tag: '/frontend/configuration/' },
  { regex: /\/announcements\/global\//, tag: '/announcements/global/' },
  { regex: /\/frontend\/href-langs\//, tag: '/frontend/href-langs/' },
  {
    regex: /\/utilities\/location-autocomplete\//,
    tag: '/utilities/location-autocomplete/',
  },
  { regex: /\/utilities\/location-geocode\//, tag: '/utilities/location-geocode/' },
  { regex: /\/frontend\/location-service\//, tag: '/frontend/location-service/' },
  { regex: /\/frontend\/seo-location-search\//, tag: '/frontend/seo-location-search/' },
  { regex: /\/announcements\/notifications\//, tag: '/announcements/notifications/' },
  { regex: /\/payment-intents\//, tag: '/payment-intents/' },
  { regex: /\/me\//, tag: '/me/' },
  { regex: /\/pets\//, tag: '/pets/' },
  { regex: /\/seo-location\//, tag: '/seo-location/' },
  { regex: /\/service-types\//, tag: '/service-types/' },
  { regex: /\/frontend\/top-cities\//, tag: '/frontend/top-cities/' },
  { regex: /\/frontend\/footer\//, tag: '/frontend/footer/' },
  { regex: /\/homepage\/configuration\//, tag: '/homepage/configuration/' },
];

export default (url: string, fallback?: string) => {
  const urlTagMap = urlTagMapArray.find(({ regex }: { regex: RegExp }) => regex.test(url));
  if (!urlTagMap) return fallback || 'unknown';
  return urlTagMap.tag;
};



// WEBPACK FOOTER //
// ../utilities/axiosUtils/getStatsdTagForUrl.js